// @ts-nocheck

import React from 'react';
import { Popover as AntPopover } from 'antd';

type Props = React.ComponentProps<typeof AntPopover> & {
  // Ширина плашки
  width?: number;
  // Размер шрифта в плашке
  fontSize?: number;
  zIndex?: number;
};

/**
 * Компонент появляющейся плашки
 */
const Popover = ({
  className,
  width,
  fontSize,
  overlayStyle,
  zIndex,
  ...props
}: Props) => (
  <AntPopover
    {...(props as any)}
    onClick={e => e.stopPropagation()}
    classNames={{ root: 'popover' }}
    styles={{
      root: {
        width,
        fontSize,
        zIndex,
        ...overlayStyle
      }
    }}
  />
);

Popover.defaultProps = {
  fontSize: 12
};

export default Popover;
